import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { Sheet, SheetContent, SheetTitle } from "@/components/ui/sheet";
import { NAV, ADMIN_NAV } from "./Sidebar";
import { useAuth } from "@/contexts/AuthContext";
import { Smartphone } from "lucide-react";

/** Drawer di navigazione per schermi piccoli (sostituisce la sidebar desktop). */
export default function MobileDrawerNav({ open, onOpenChange }) {
  const { user } = useAuth();
  const nav = useNavigate();
  const role = user?.role || "admin";
  const filt = (items) => items.filter((it) => !it.roles || it.roles.includes(role));
  const close = () => onOpenChange(false);

  const Section = ({ label, items }) =>
    items.length === 0 ? null : (
      <div className="mb-2">
        <p className="px-5 pt-3 pb-1.5 text-[9px] uppercase tracking-[0.2em] font-semibold" style={{ color: "rgba(100,116,139,0.8)" }}>
          {label}
        </p>
        {items.map((it) => {
          const Icon = it.icon;
          return (
            <NavLink
              key={it.to}
              to={it.to}
              end={it.end}
              onClick={close}
              data-testid={`drawer-${it.testid || it.to}`}
              className="flex items-center gap-3 px-5 py-[11px] text-[13.5px] font-medium transition-colors"
              style={({ isActive }) =>
                isActive
                  ? { background: "rgba(183,149,91,0.14)", borderLeft: "3px solid #B7955B", color: "#fff" }
                  : { color: "rgba(148,163,184,0.9)", borderLeft: "3px solid transparent" }
              }
            >
              <Icon className="w-[16px] h-[16px] shrink-0" strokeWidth={1.7} />
              <span className="truncate">{it.label}</span>
            </NavLink>
          );
        })}
      </div>
    );

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        side="left"
        className="p-0 w-[270px] border-0 gap-0 [&>button]:text-white [&>button]:opacity-70"
        style={{ background: "#0A192F" }}
        data-testid="mobile-drawer-nav"
      >
        <SheetTitle className="sr-only">Menu di navigazione</SheetTitle>
        <div className="flex flex-col h-full">
          {/* Logo + utente */}
          <div className="px-5 pt-5 pb-4" style={{ borderBottom: "1px solid rgba(255,255,255,0.07)" }}>
            <p className="font-serif text-[18px] text-white leading-tight">
              Best <span style={{ color: "#D4AB6E" }}>Agent</span>
            </p>
            <p className="text-[10.5px] mt-0.5 truncate" style={{ color: "rgba(148,163,184,0.7)" }}>
              {user?.name || user?.email || ""}
            </p>
          </div>

          {/* Nav */}
          <nav className="flex-1 overflow-y-auto py-1">
            <Section label="Console operativa" items={filt(NAV)} />
            <Section label="Amministrazione" items={filt(ADMIN_NAV)} />
          </nav>

          {/* Torna alla versione mobile */}
          <button
            type="button"
            onClick={() => { try { sessionStorage.removeItem("forceDesktop"); } catch {} close(); nav("/m"); }}
            data-testid="drawer-back-to-mobile"
            className="m-4 flex items-center justify-center gap-2 py-3 rounded-xl text-[12.5px] font-semibold active:scale-[0.98] transition-transform"
            style={{ background: "rgba(183,149,91,0.15)", color: "#D4AB6E", border: "1px solid rgba(183,149,91,0.3)" }}
          >
            <Smartphone className="w-4 h-4" strokeWidth={2} />
            Torna alla versione mobile
          </button>
        </div>
      </SheetContent>
    </Sheet>
  );
}
